// =============================================================================
// User
// =============================================================================
import {
  useGetSchoolCandidateAppealPaymentOpenPeriod
} from "../api-refactored/school-candidate-payment/useGetSchoolCandidateAppealPaymentOpenPeriod";

export const GET_USER_DETAILS_QUERY_KEY = 'GET_USER_DETAILS';

export const GET_OTP_DETAILS_QUERY_KEY = 'GET_OTP_DETAILS';

export const GET_RESET_LINK_VALIDITY_QUERY_KEY = 'GET_RESET_LINK_VALIDITY';

export const GET_USER_GRANTED_ACCESS = 'GET_USER_GRANTED_ACCESS';

export const GET_ACTION_REQUEST_LIST_QUERY_KEY = 'GET_ACTION_REQUEST_LIST';
export const GET_ACTION_REQUESTER_REQUEST_LIST_QUERY_KEY = 'GET_ACTION_REQUESTER_REQUEST_LIST';

export const GET_ACTION_TYPES_QUERY_KEY = 'GET_ACTION_TYPES';
export const GET_ACCOUNT_ACTION_TYPES_QUERY_KEY = 'GET_ACCOUNT_ACTION_TYPES';
export const GET_OPS_ADMIN_ACCOUNT_ACTION_TYPES_QUERY_KEY = 'GET_OPS_ADMIN_ACCOUNT_ACTION_TYPES';

export const GET_SINGPASS_CONSENT_QUERY_KEY = 'GET_SINGPASS_CONSENT';
export const GET_MIMS_AUTH_KEY = 'GET_MIMS_CONSENT';
export const GET_MIMS_STATUS_KEY = 'GET_MIMS_STATUS';

export const GET_USER_LIST_QUERY_KEY = 'GET_USER_LIST';
export const GET_USER_GROUP_QUERY_KEY = 'GET_USER_GROUP';

export const GET_IEXAM2_DETAILS_QUERY_KEY = 'GET_IEXAM2_DETAILS';
export const GET_APPROVERS_QUERY_KEY = 'GET_APPROVERS';

export const GET_ORGANISATION_LIST_QUERY_KEY = 'GET_ORGANISATION_LIST';
export const GET_ORGANISATION_UUID_LIST_QUERY_KEY = 'GET_ORGANISATION_UUID_LIST';

export const GET_USER_SETTINGS_QUERY_KEY = 'GET_SETTINGS';

export const GET_ACCESS_CONFIG_QUERY_KEY = 'GET_ACCESS_CONFIG';

export const GET_ACCESS_ROLE_QUERY_KEY = 'GET_ACCESS_ROLE';

export const GET_CANDIDATE_QUERY_KEY = 'GET_CANDIDATE';
export const GET_COORDINATOR_QUERY_KEY = 'GET_COORDINATOR';
export const GET_OPS_ADMIN_QUERY_KEY = 'GET_OPS_ADMIN';

export const GET_CANDIDATE_PROFILE_DETAILS_QUERY_KEY = 'GET_CANDIDATE_PROFILE_DETAILS';

export const GET_ADMIN_PROFILE_DETAILS_QUERY_KEY = 'GET_ADMIN_PROFILE_DETAILS';

export const GET_AUDIT_ELIGIBILITY_QUERY_KEY = 'GET_AUDIT_ELIGBILITY';

export const GET_CHECK_AUDIT_REPORT_ELIGIBILITY_QUERY_KEY = 'GET_AUDIT_REPORT_ELIGIBILITY';

export const GET_COORDINATOR_PROFILE_QUERY_KEY = 'GET_COORDINATOR_PROFILE';

export const GET_CAPTCHA_SITE_KEY_QUERY_KEY = 'GET_CAPTCHA_SITE_KEY';

export const GET_SCHOOLS_BY_TYPE_QUERY_KEY = 'GET_SCHOOLS_BY_TYPE';

export const GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE_QUERY_KEY =
  'GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE';

export const GET_AUTHORITY_EXIST_FOR_LOGGED_IN_USER_KEY =
  'GET_AUTHORITY_EXIST_FOR_LOGGED_IN_USER_KEY';

export const GET_ORGANISATIONS_QUERY_KEY = 'GET_ORGANISATIONS_QUERY_KEY';

// =============================================================================
// Candidate
// =============================================================================
export const GET_ADDRESS_DETAILS_KEY = 'GET_ADDRESS_DETAILS_KEY';
export const GET_PAYMENT_STATUS_QUERY_KEY = 'GET_PAYMENT_STATUS';
export const GET_GROUP_EXAM_REGISTRATION_SUMMARY_QUERY_KEY = 'GET_GROUP_EXAM_REGISTRATION_SUMMARY';
export const GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL_QUERY_KEY =
  'GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL';
export const GET_GROUP_EXAM_REGISTRATION_ELIGIBILITY_QUERY_KEY =
  'GET_GROUP_EXAM_REGISTRATION_ELIGIBILITY';
export const GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS_QUERY_KEY =
  'GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS';
export const GET_GROUP_EXAM_REGISTRATIONS_QUERY_KEY = 'GET_GROUP_EXAM_REGISTRATIONS_QUERY_KEY';
export const GET_DOWNLOAD_ERROR_FILE_URL_QUERY_KEY = 'GET_DOWNLOAD_ERROR_FILE_URL';
export const GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS_QUERY_KEY =
  'GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS_QUERY_KEY';
export const GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_QUERY_KEY =
  'GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_QUERY_KEY';

export const GET_ENABLED_MEDICAL_CONDITIONS_QUERY_KEY = 'GET_ENABLED_MEDICAL_CONDITIONS';
export const GET_DROPDOWN_MEDICAL_CONDITIONS_QUERY_KEY = 'GET_DROPDOWN_MEDICAL_CONDITIONS';

export const GET_ENABLED_REQUEST_TYPES_QUERY_KEY = 'GET_ENABLED_REQUEST_TYPES';
export const GET_DROPDOWN_REQUEST_TYPES_QUERY_KEY = 'GET_DROPDOWN_REQUEST_TYPES';

export const GET_DOWNLOAD_ENTRY_PROOF_FILE_QUERY_KEY = 'GET_DOWNLOAD_ENTRY_PROOF_FILE';
export const GET_COORDINATOR_EXAM_LEVELS_QUERY_KEY = 'GET_COORDINATOR_EXAM_LEVELS';

export const GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_QUERY_KEY =
  'GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_QUERY_KEY';

export const GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_QUERY_KEY =
  'GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION';

export const GET_EXAM_SERIES_QUERY_KEY = 'GET_EXAM_SERIES_QUERY_KEY';

export const GET_UPLOADED_FILE_INFO_QUERY_KEY = 'GET_UPLOADED_FILE_INFO_QUERY_KEY';

export const GET_NON_NATIONAL_INCOMPLETE_DETAILS_QUERY_KEY =
  'GET_NON_NATIONAL_INCOMPLETE_DETAILS_QUERY_KEY';

export const GET_ADMISSION_EXAM_YEARS_QUERY_KEY = 'GET_ADMISSION_EXAM_YEARS_QUERY_KEY';

export const GET_ADMISSION_LEVEL_VACANCIES_QUERY_KEY = 'GET_ADMISSION_LEVEL_VACANCIES_QUERY_KEY';

export const GET_UNUSED_EXAM_LEVELS_QUERY_KEY = 'GET_UNUSED_EXAM_LEVELS_QUERY_KEY';

export const GET_GSC_DOWNLOAD_TEMPLATE_QUERY_KEY = 'GET_GSC_DOWNLOAD_TEMPLATE_QUERY_KEY';

export const GET_GSC_REQUEST_SUMMARY_QUERY_KEY = 'GET_GSC_REQUEST_SUMMARY_QUERY_KEY';

export const GET_GSC_DOWNLOAD_ERROR_FILE_QUERY_KEY = 'GET_GSC_DOWNLOAD_ERROR_FILE_QUERY_KEY';

export const GET_EXAM_CONFIGURATION_EXAM_TYPE_QUERY_KEY = 'GET_EXAM_TYPE_QUERY_KEY';
export const GET_FILE_BULK_PROCESSING_STATUS_QUERY_KEY = 'GET_FILE_BULK_PROCESSING_STATUS';

export const GET_EXAM_CONFIGURATION_FEATURE_TYPE_QUERY_KEY =
  'GET_EXAM_CONFIGURATION_FEATURE_TYPE_QUERY_KEY';

export const GET_LAST_UPDATED_INFO_QUERY_KEY = 'GET_LAST_UPDATED_INFO_QUERY_KEY';
export const GET_GSC_REVIEW_KEY = 'GET_GSC_REVIEW_KEY';
export const GET_GSC_INDIVIDUAL_RANKING_KEY = 'GET_GSC_INDIVIDUAL_RANKING_KEY';
export const GET_GSC_SUMMARY_KEY = 'GET_GSC_SUMMARY_KEY';

export const GET_GSC_CHECK_EXISTING_DRAFT_QUERY_KEY = 'GET_GSC_CHECK_EXISTING_DRAFT_QUERY_KEY';

export const GET_GSC_UPLOADED_FILE_INFO_QUERY_KEY = 'GET_GSC_UPLOADED_FILE_INFO_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_SUMMARY_PDF_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_SUMMARY_PDF_QUERY_KEY';

export const GET_PARENT_DETAIL_TYPES_QUERY_KEY = 'GET_PARENT_DETAIL_TYPES_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_SUMMARY_QUERY_KEY = 'GET_NON_NATIONAL_EXAM_SUMMARY_QUERY_KEY';

export const GET_NON_NATIONAL_APPLICATION_STATUS_QUERY_KEY =
  'GET_NON_NATIONAL_APPLICATION_STATUS_QUERY_KEY';

export const GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS_QUERY_KEY =
  'GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS_QUERY_KEY';

export const GET_USER_CITIZEN_SHIPS_QUERY_KEY = 'GET_USER_CITIZEN_SHIPS_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_TYPE_QUERY_KEY = 'GET_NON_NATIONAL_EXAM_TYPE_QUERY_KEY';

export const GET_RESIT_REGISTRATION_REVIEW_KEY = 'GET_RESIT_REGISTRATION_REVIEW_KEY';
export const GET_RESIT_SUBJECTS_KEY = 'GET_RESIT_SUBJECTS_KEY';

export const GET_RESIT_EXAM_LEVELS_KEY = 'GET_RESIT_EXAM_LEVELS_KEY';
export const GET_RESIT_CHECK_REGISTRATION_STATUS = 'GET_RESIT_CHECK_REGISTRATION_STATUS';

export const GET_GROUP_RESIT_FEE_PROCESSING_STATUS_KEY =
  'GET_GROUP_RESIT_FEE_PROCESSING_STATUS_KEY';

export const GET_GROUP_RESIT_REGISTRATION_REVIEW_KEY = 'GET_GROUP_RESIT_REGISTRATION_REVIEW_KEY';

export const GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS_KEY =
  'GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS_KEY';

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_QUERY_KEY';

export const GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_QUERY_KEY =
  'GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_QUERY_KEY';

export const GET_UPCOMING_SUBJECT_PAPER_KEY = 'GET_UPCOMING_SUBJECT_PAPER_KEY';

export const GET_EXAM_LEVEL_QUERY_KEY = 'GET_EXAM_LEVEL_QUERY_KEY';

export const GET_MY_INFO_CONSENT_FORM_QUERY_KEY = 'GET_MY_INFO_CONSENT_FORM_QUERY_KEY';

export const GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_OPEN_PERIOD_QUERY_KEY = 'GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_OPEN_PERIOD_QUERY_KEY';
// =============================================================================
// Utils
// =============================================================================
export const GET_FILE_UPLOAD_STATUS_QUERY_KEY = 'GET_FILE_UPLOAD_STATUS';
export const GET_APPLICATION_FILE_INFORMATION_QUERY_KEY = 'GET_APPLICATION_FILE_INFORMATION';

export const GET_EXAM_TYPE_QUERY_KEY = 'GET_EXAM_TYPE';

export const GET_APPLICATION_FILES_CONFIG_QUERY_KEY = 'GET_APPLICATION_FILES_CONFIG_QUERY_KEY';

export const GET_INTENDED_RESIDENTIAL_AREA_QUERY_KEY = 'GET_INTENDED_RESIDENTIAL_AREA_QUERY_KEY';

export const GET_INTENDED_RESIDENTIAL_ZONE_QUERY_KEY = 'GET_INTENDED_RESIDENTIAL_ZONE_QUERY_KEY';

export const GET_WORK_PASS_TYPES_QUERY_KEY = 'GET_WORK_PASS_TYPES_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_COUNTRY_QUERY_KEY = 'GET_NON_NATIONAL_EXAM_COUNTRY_QUERY_KEY';

export const GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS_QUERY_KEY =
  'GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS_QUERY_KEY';

export const GET_AEIS_ADDITIONAL_DETAILS_QUERY_KEY = 'GET_AEIS_ADDITIONAL_DETAILS_QUERY_KEY';

export const GET_SPE_ADDITIONAL_DETAILS_QUERY_KEY = 'GET_SPE_ADDITIONAL_DETAILS_QUERY_KEY';

export const GET_ACCOUNT_STATUS_QUERY_KEY = 'GET_ACCOUNT_STATUS_QUERY_KEY';
// =============================================================================
// Financial
// =============================================================================

// =============================================================================
// Unique Link
// =============================================================================
export const GET_UNIQUE_LINK_DETAILS_QUERY_KEY = 'GET_UNIQUE_LINK_DETAILS_QUERY_KEY';
export const GET_REGISTRATIONS_EXAM_LEVELS_QUERY_KEY = 'GET_REGISTRATIONS_EXAM_LEVELS_QUERY_KEY';

export const NON_NATIONAL_APPLICATION_STATUS_DROPDOWN_QUERY_KEY =
  'NON_NATIONAL_APPLICATION_STATUS_DROPDOWN_QUERY_KEY';
export const NON_NATIONAL_APPLICATION_WITHDRAWAL_STATUS_DROPDOWN_QUERY_KEY =
  'NON_NATIONAL_APPLICATION_WITHDRAWAL_STATUS_DROPDOWN_QUERY_KEY';

export const GET_ADMIN_AUDIT_LOG_QUERY_KEY = 'GET_ADMIN_AUDIT_LOG_QUERY_KEY';

export const GET_EXEMPTION_RULES_DROPDOWN_QUERY_KEY = 'GET_EXEMPTION_RULES_DROPDOWN_QUERY_KEY';

export const GET_UNIQUE_LINK_SUBJECT_DETAILS_QUERY_KEY =
  'GET_UNIQUE_LINK_SUBJECT_DETAILS_QUERY_KEY';

export const GET_COORDINATOR_UNIQUE_LINK_COUNT_QUERY_KEY =
  'GET_COORDINATOR_UNIQUE_LINK_COUNT_QUERY_KEY';
export const GET_UNIQUE_LINK_LISTING_QUERY_KEY = 'GET_UNIQUE_LINK_LISTING_QUERY_KEY';

export const GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_QUERY_KEY =
  'GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_QUERY_KEY';
export const GET_WITHDRAWAL_UNIQUE_LINK_LISTING_QUERY_KEY =
  'GET_WITHDRAWAL_UNIQUE_LINK_LISTING_QUERY_KEY';
export const GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_QUERY_KEY =
  'GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_QUERY_KEY';

// =============================================================================
// Appeal
// =============================================================================
export const GET_APPEAL_ACCESS_QUERY_KEY = 'GET_APPEAL_ACCESS_QUERY_KEY';
export const GET_COORDINATOR_APPEAL_LISTING_QUERY_KEY = 'GET_COORDINATOR_APPEAL_LISTING';
export const GET_COORDINATOR_APPEAL_EXAM_LEVEL_QUERY_KEY =
  'GET_COORDINATOR_APPEAL_EXAM_LEVEL_QUERY_KEY';
export const GET_COORDINATOR_APPEAL_SELECT_SUBJECT_QUERY_KEY =
  'GET_COORDINATOR_APPEAL_SELECT_SUBJECT_QUERY_KEY';
export const GET_COORDINATOR_APPEAL_REVIEW_QUERY_KEY = 'GET_COORDINATOR_APPEAL_REVIEW_QUERY_KEY';
export const GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_QUERY_KEY =
  'GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_QUERY_KEY';
export const GET_COORDINATOR_APPEAL_SUMMARY_QUERY_KEY = 'GET_COORDINATOR_APPEAL_SUMMARY_QUERY_KEY';
export const GET_APPEAL_OUTCOME_KEY = 'GET_APPEAL_ACCESS_QUERY_KEY';

// =============================================================================
// Online Tutorials
// =============================================================================
export const GET_EXAM_LEVEL_AND_RESOURCE_TYPES_QUERY_KEY =
  'GET_EXAM_LEVEL_AND_RESOURCE_TYPES_QUERY_KEY';
export const GET_RESOURCE_FILE_CONFIG_QUERY_KEY = 'GET_RESOURCE_FILE_CONFIG_QUERY_KEY';
export const GET_RESOURCE_QUERY_KEY = 'GET_RESOURCE_QUERY_KEY';
export const GET_DOCUMENT_DOWNLOAD_QUERY_KEY = 'GET_DOCUMENT_DOWNLOAD_QUERY_KEY';
export const GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT_QUERY_KEY =
  'GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT_QUERY_KEY';
// =============================================================================
// Non-National
// =============================================================================
export const GET_NON_NATIONAL_EXAM_GROUPS_QUERY_KEY = 'GET_NON_NATIONAL_EXAM_GROUPS_QUERY_KEY';

// =============================================================================
// Announcements & Notification
// =============================================================================
export const GET_ADMIN_ANNOUNCEMENT_CONFIG_QUERY_KEY = 'GET_ADMIN_ANNOUNCEMENT_CONFIG_QUERY_KEY';
export const GET_ANNOUNCEMENT_DETAILS_QUERY_KEY = 'GET_ANNOUNCEMENT_DETAILS_QUERY_KEY';
export const GET_ANNOUNCEMENT_FEATURE_QUERY_KEY = 'GET_ANNOUNCEMENT_FEATURE_QUERY_KEY';
export const GET_ANNOUNCEMENT_CANDIDATE_TYPES_QUERY_KEY =
  'GET_ANNOUNCEMENT_CANDIDATE_TYPES_QUERY_KEY';
export const GET_ANNOUNCEMENT_EXAM_LEVELS_QUERY_KEY = 'GET_ANNOUNCEMENT_EXAM_LEVELS_QUERY_KEY';
export const GET_ANNOUNCEMENT_EXAM_CENTRES_QUERY_KEY = 'GET_ANNOUNCEMENT_EXAM_CENTRES_QUERY_KEY';

export const GET_NOTIFICATION_FEATURE_QUERY_KEY = 'GET_NOTIFICATION_FEATURE_QUERY_KEY';
export const GET_NOTIFICATION_DETAILS_QUERY_KEY = 'GET_NOTIFICATION_DETAILS_QUERY_KEY';
export const GET_NOTIFICATION_VIEW_DETAILS_QUERY_KEY = 'GET_NOTIFICATION_VIEW_DETAILS_QUERY_KEY';
export const GET_NOTIFICATION_TEMPLATE_DETAILS_QUERY_KEY =
  'GET_NOTIFICATION_TEMPLATE_DETAILS_QUERY_KEY';
export const GET_CHECK_NOTIFICATION_REPORT_ELIGIBILITY_QUERY_KEY =
  'GET_CHECK_NOTIFICATION_REPORT_ELIGIBILITY_QUERY_KEY';

export const GET_ADMIN_APPLICATION_FILE_CONFIGS_QUERY_KEY =
  'GET_ADMIN_APPLICATION_FILE_CONFIGS_QUERY_KEY';
export const GET_ADMIN_APPLICATION_FILE_STATUS_QUERY_KEY =
  'GET_ADMIN_APPLICATION_FILE_STATUS_QUERY_KEY';
export const GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_QUERY_KEY =
  'GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_QUERY_KEY';
export const GET_ANNOUNCEMENT_CONFIG_QUERY_KEY = 'GET_ANNOUNCEMENT_CONFIG_QUERY_KEY';
export const GET_PRIORITY_ANNOUNCEMENT_QUERY_KEY = 'GET_PRIORITY_ANNOUNCEMENT_QUERY_KEY';
export const GET_NON_PRIORITY_ANNOUNCEMENT_QUERY_KEY = 'GET_NON_PRIORITY_ANNOUNCEMENT_QUERY_KEY';
export const GET_ANNOUNCEMENT_NOTICE_DETAILS_QUERY_KEY =
  'GET_ANNOUNCEMENT_NOTICE_DETAILS_QUERY_KEY';

// =============================================================================
// Audit Settings
// =============================================================================
export const GET_AUDIT_SETTINGS_REPORT_QUERY_KEY = 'GET_AUDIT_SETTINGS_REPORT_QUERY_KEY';
export const GET_RETRIEVE_AUDIT_SETTINGS_QUERY_KEY = 'GET_RETRIEVE_AUDIT_SETTINGS_QUERY_KEY';

// =============================================================================
// Data Archival
// =============================================================================
export const POST_DATA_ARCHIVAL_LISTING = 'POST_DATA_ARCHIVAL_LISTING';
export const GET_DATA_ARCHIVAL_FILTER_YEAR = 'GET_DATA_ARCHIVAL_FILTER_YEAR';
export const GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL = 'GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL';
export const GET_DATA_ARCHIVAL_TEMPLATE = 'GET_DATA_ARCHIVAL_TEMPLATE'; // data groups
export const POST_CREATE_DATA_ARCHIVAL = 'POST_CREATE_DATA_ARCHIVAL';
export const GET_DATA_ARCHIVAL_DETAIL = 'GET_DATA_ARCHIVAL_DETAIL';

// =============================================================================
// Data Archival Report
// =============================================================================
export const GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL =
  'GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL';

// =============================================================================
// Profile Amendment Requests
// =============================================================================
export const GET_PROFILE_AMENDMENT_REQUESTS_QUERY_KEY = 'GET_PROFILE_AMENDMENT_REQUESTS_QUERY_KEY';
export const GET_PROFILE_AMENDMENT_REQUEST_FILTER_QUERY_KEY =
  'GET_PROFILE_AMENDMENT_REQUEST_FILTER_QUERY_KEY';
export const GET_PROFILE_AMENDMENT_REQUEST_STATUSES_QUERY_KEY =
  'GET_PROFILE_AMENDMENT_REQUEST_STATUSES_QUERY_KEY';
export const GET_PROFILE_AMENDMENT_REQUEST_DETAILS_QUERY_KEY =
  'GET_PROFILE_AMENDMENT_REQUEST_DETAILS_QUERY_KEY';
export const GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_QUERY_KEY =
  'GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_QUERY_KEY';
export const GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_QUERY_KEY =
  'GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_QUERY_KEY';

// =============================================================================
// Job Status Report
// =============================================================================
export const GET_JOB_STATUS_REPORT_NAME_KEY = 'GET_JOB_STATUS_REPORT_NAME_KEY';

// =============================================================================
// Record Status
// =============================================================================
export const GET_RECORD_STATUS_KEY = 'GET_RECORD_STATUS_KEY';
export const GET_JOB_STATUS_RECORD_DETAILS_QUERY_KEY = 'GET_JOB_STATUS_RECORD_DETAILS_QUERY_KEY';

// =============================================================================
// Transaction Related
// =============================================================================
export const GET_TRANSACTION_QUERY_KEY = 'GET_TRANSACTION_QUERY_KEY';

// =============================================================================
// Valid CEQ Test Date
// =============================================================================
export const GET_VALID_CEQ_TEST_DATE_LISTING_QUERY_KEY =
  'GET_VALID_CEQ_TEST_DATE_LISTING_QUERY_KEY';
export const GET_VALID_CEQ_TEST_DATES_QUERY_KEY = 'GET_VALID_CEQ_TEST_DATES_QUERY_KEY';

// =============================================================================
// School Canidate Payment
// =============================================================================
export const GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT_QUERY_KEY =
  'GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT_QUERY_KEY';
export const GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS_QUERY_KEY =
  'GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS_QUERY_KEY';
export const GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT_QUERY_KEY =
  'GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT_QUERY_KEY';
